import { MARKING_MODES } from "./constants";

function isHolisticMarking(assignmentPreferences) {
  try {
    let prefs = assignmentPreferences;

    // 1. If it's a string, parse it into an object
    if (typeof prefs === "string") {
      prefs = JSON.parse(prefs);
    }
    // 2. Safeguard against null/undefined after parsing
    if (!prefs) return false;

    // 3. Check the marking_mode property
    // Note: Using 'marking_mode' (snake_case) to match your Python/Pydantic schema
    return prefs?.marking_mode === MARKING_MODES.HOLISTIC;
  } catch (error) {
    console.error("Failed to parse or read assignment preferences:", error);
    return false;
  }
}

export { isHolisticMarking };
